import { Component } from '@angular/core';

@Component({
    selector: 'tt-edi-menu',
    templateUrl: './edi-menu.component.html',
    styleUrls: ['./edi-menu.component.css'],
    standalone: false,
})
export class EdiMenuComponent {
    public readonly name = 'edimenu';
}
